// extracted by mini-css-extract-plugin
module.exports = {"icon":"Spinner_icon__3hBU3","sm":"Spinner_sm__1kR_U","md":"Spinner_md__pyMGV","lg":"Spinner_lg__3HjBt","spinner":"Spinner_spinner__ty_2R","spin":"Spinner_spin__3koDe"};